import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';
import { CurrencyPipe } from '@angular/common';

@Injectable({ providedIn: 'root' })
@Pipe({ standalone: true, name: 'currencyFormat' })

export class CurrencyFormatPipe implements PipeTransform {
	constructor(private currencyPipe: CurrencyPipe) {}

	public transform(value: number): string {
		if (value === null) return null;

		return this.currencyPipe.transform(
			value,
			environment.currency.code,
			'symbol',
			'1.2-2',
			environment.currency.locale
		);
	}
}